<template>
  <div>
    <main role="main">
      <b-carousel
        id="carousel-fade"
        style="text-shadow: 0px 0px 2px #000"
        fade
        indicators
        img-width="1024"
        img-height="480"
      >
        <b-carousel-slide
          caption="Amazing Tools For Guides"
          img-src="/resources/images/content/splash1.jpg"
        ></b-carousel-slide>
        <b-carousel-slide
          caption="Second Slide"
          img-src="/resources/images/content/splash2.jpg"
        ></b-carousel-slide>
        <b-carousel-slide
          caption="Third Slide"
          img-src="https://picsum.photos/1024/480/?image=22"
        ></b-carousel-slide>
      </b-carousel>
      <div
        v-if="!guideApplication && !guideApplicationSubmitted"
        style="margin-bottom: 20px"
      >
        <b-button block class="btn btn-success" @click="handleApplyBtnClick"
          >Apply For Guide Role</b-button
        >
        <p v-if="profileInCompleteError">
          {{ profileInCompleteError }}
          Go to <a @click="handleErrorGoToProfileClick">Profile</a>.
        </p>
      </div>
      <div v-else>
        <p>
          Thanks for applying- Your application is being reviewed.
        </p>
      </div>
      <!--TODO: Break up into sections -->
      <div class="container marketing">
        <!-- Three columns of text below the carousel -->
        <div class="row">
          <div class="col-lg-4">
            <img
              class="rounded-circle"
              src="/resources/images/content/splash1.jpg"
              alt="Generic placeholder image"
              width="140"
              height="140"
            />
            <h2>Join Today</h2>
            <p>
              Membership includes a directory listing, business opportunities,
              training, and a platform for turning your expertise into extra
              income.
            </p>
            <p>
              <a class="btn btn-secondary" href="#" role="button"
                >View details &raquo;</a
              >
            </p>
          </div>
          <!-- /.col-lg-4 -->
          <div class="col-lg-4">
            <img
              class="rounded-circle"
              src="/resources/images/content/splash2.jpg"
              alt="Generic placeholder image"
              width="140"
              height="140"
            />
            <h2>List Your Expert Skills</h2>
            <p>
              Our directory and referral program are both powerful ways to get
              new clients. All you have to do is put your coaching services into
              one of our beautiful coaching profiles.
            </p>
            <p>
              <a class="btn btn-secondary" href="#" role="button"
                >View details &raquo;</a
              >
            </p>
          </div>
          <!-- /.col-lg-4 -->
          <div class="col-lg-4">
            <img
              class="rounded-circle"
              src="/resources/images/content/splash1.jpg"
              alt="Generic placeholder image"
              width="140"
              height="140"
            />
            <h2>Grow Your Business</h2>
            <p>Our number one goal is to bring you business opportunities.</p>
            <p>
              <a class="btn btn-secondary" href="#" role="button"
                >View details &raquo;</a
              >
            </p>
          </div>
          <!-- /.col-lg-4 -->
        </div>
        <!-- /.row -->

        <!-- START THE FEATURETTES -->

        <hr class="featurette-divider" />

        <div class="row featurette">
          <div class="col-md-7">
            <h2 class="featurette-heading">
              Sell Your Coaching Services<span class="text-muted"
                >Get paid today.</span
              >
            </h2>
            <p class="lead">
              Our platform supports two types of coaching services: digital
              text-based coaching and traditional session or video based
              coaching.
            </p>
          </div>
          <div class="col-md-5">
            <img
              class="featurette-image img-fluid mx-auto"
              src="/resources/images/content/isometric2.png"
              alt="Generic placeholder image"
            />
          </div>
        </div>

        <hr class="featurette-divider" />

        <div class="row featurette">
          <div class="col-md-7 order-md-2">
            <h2 class="featurette-heading">Become a Guide</h2>
            <p class="lead">
              Never coached before? Our behavioral coaching certification is the
              best in the world. It's also a simple starting point for new
              coaches.
            </p>
          </div>
          <div class="col-md-5 order-md-1">
            <img
              class="featurette-image img-fluid mx-auto"
              src="/resources/images/content/isometric2.png"
              alt="Isometric placeholder image"
            />
          </div>
        </div>

        <hr class="featurette-divider" />

        <div class="row featurette">
          <div class="col-md-7">
            <h2 class="featurette-heading">
              And lastly, this one. <span class="text-muted">Checkmate.</span>
            </h2>
            <p class="lead">
              Accountability, advice and support from other coaches on how to
              succeed at social media marketing. Plus cash prizes.
            </p>
          </div>
          <div class="col-md-5">
            <img
              class="featurette-image img-fluid mx-auto"
              src="/resources/images/content/isometric.png"
              alt="Generic placeholder image"
            />
          </div>
        </div>
        <!-- /END THE FEATURETTES -->
      </div>
      <!-- /.container -->
    </main>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  computed: {
    ...mapGetters({
      user: "user/user",
      profile: "user/profile"
    })
  },
  methods: {
    handleApplyBtnClick() {
      //@ToDo- Can Validation be done here? Vee-Validate
      let missingData = "";
      if (!this.profile.firstname || this.profile.firstname.trim().length === 0)
        missingData = missingData + "First Name,";
      if (!this.profile.lastname || this.profile.lastname.trim().length === 0)
        missingData = missingData + "Last Name,";
      if (!this.profile.email || this.profile.email.trim().length === 0)
        missingData = missingData + "Email,";
      if (!this.profile.imgURL || this.profile.imgURL.trim().length === 0)
        missingData = missingData + "Profile Picture";

      if (missingData.length > 0) {
        this.profileInCompleteError = `Please add your ${missingData}`;
      } else {
        this.guideApplicationSubmitted = true;
        let profile = {
          email: this.profile.email,
          imgURL: this.profile.imgURL,
          firstname: this.profile.firstname,
          lastname: this.profile.lastname,
          phoneNumber: this.profile.phoneNumber,
          userId: this.profile.userId
        };

        this.$store
          .dispatch("listings/guideApply", profile)
          .then(() => {
            this.$nprogress.done();
          })
          .catch(error => {
            this.$nprogress.done();
            this.$store.dispatch("user/showNotification", {
              title: error.code,
              description: error.message,
              variant: "danger"
            });
          });
      }
    },
    handleErrorGoToProfileClick() {
      this.$router.push("/me");
    }
  },
  mounted() {
    // debugger;
    this.$store
      .dispatch("listings/getGuideById", this.profile)
      .then(guide => {
        this.guideApplication = guide;
      })
      .catch(error => {
        this.$nprogress.done();
        this.$store.dispatch("user/showNotification", {
          title: error.code,
          description: error.message,
          variant: "danger"
        });
      });
  },
  data: function() {
    return {
      profileInCompleteError: null,
      guideApplication: null,
      guideApplicationSubmitted: false
    };
  }
};
</script>

<style lang="scss" scoped>
/* GLOBAL STYLES
-------------------------------------------------- */
/* Padding below the footer and lighter body text */

body {
  padding-top: 3rem;
  padding-bottom: 3rem;
  color: #5a5a5a;
}

/* CUSTOMIZE THE CAROUSEL
  -------------------------------------------------- */

/* Carousel base class */
.carousel {
  margin-bottom: 4rem;
}
/* Since positioning the image, we need to help out the caption */
.carousel-caption {
  bottom: 3rem;
  z-index: 10;
}

/* Declare heights because of positioning of img element */
.carousel-item {
  height: 32rem;
  background-color: #777;
}
.carousel-item > img {
  position: absolute;
  top: 0;
  left: 0;
  min-width: 100%;
  height: 32rem;
}

/* MARKETING CONTENT
  -------------------------------------------------- */

/* Center align the text within the three columns below the carousel */
.marketing .col-lg-4 {
  margin-bottom: 1.5rem;
  text-align: center;
}
.marketing h2 {
  font-weight: 400;
}
.marketing .col-lg-4 p {
  margin-right: 0.75rem;
  margin-left: 0.75rem;
}

/* Featurettes
  ------------------------- */

.featurette-divider {
  margin: 5rem 0; /* Space out the Bootstrap <hr> more */
}

/* Thin out the marketing headings */
.featurette-heading {
  font-weight: 300;
  line-height: 1;
  letter-spacing: -0.05rem;
}

/* RESPONSIVE CSS
  -------------------------------------------------- */

@media (min-width: 40em) {
  /* Bump up size of carousel content */
  .carousel-caption p {
    margin-bottom: 1.25rem;
    font-size: 1.25rem;
    line-height: 1.4;
  }

  .featurette-heading {
    font-size: 50px;
  }
}

@media (min-width: 62em) {
  .featurette-heading {
    margin-top: 7rem;
  }
}
</style>
